/**
 * CSV для Excel по-казахстански: BOM для кириллицы, «;» как разделитель
 * (у русской локали Excel запятая — десятичная), деньги — числом в тенге.
 */
export function downloadCsv(filename: string, rows: (string | number)[][]): void {
  const cell = (c: string | number) => {
    const s = typeof c === 'number' ? String(c).replace('.', ',') : c;
    return /[";\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const csv = '\ufeff' + rows.map((r) => r.map(cell).join(';')).join('\r\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}

/** Тиыны → тенге числом для табличных ячеек. */
export const tg = (tiyn: number): number => tiyn / 100;

/** Excel-совместимый SpreadsheetML (.xls): числа остаются числами,
 *  кириллица не ломается — без единой библиотеки. */
export function downloadXls(filename: string, rows: (string | number)[][]) {
  const esc = (s: string) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  const cells = (r: (string | number)[]) => r.map((c) =>
    typeof c === 'number'
      ? `<Cell><Data ss:Type="Number">${c}</Data></Cell>`
      : `<Cell><Data ss:Type="String">${esc(c)}</Data></Cell>`).join('');
  const xml = `<?xml version="1.0" encoding="UTF-8"?>
<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"
 xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">
<Worksheet ss:Name="Лист1"><Table>
${rows.map((r) => `<Row>${cells(r)}</Row>`).join('\n')}
</Table></Worksheet></Workbook>`;
  const blob = new Blob(['\ufeff' + xml], { type: 'application/vnd.ms-excel' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}
